import { motion } from "framer-motion";

export const EASE = [0.16, 1, 0.3, 1];

export function FadeUp({ children, delay = 0, y = 28, className = "" }) {
    return (
        <motion.div
            className={className}
            initial={{ opacity: 0, y }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.15 }}
            transition={{ duration: 0.7, ease: EASE, delay }}
        >
            {children}
        </motion.div>
    );
}

export function Stagger({ children, className = "", gap = 0.08, delay = 0 }) {
    return (
        <motion.div
            className={className}
            initial="hide"
            whileInView="show"
            viewport={{ once: true, amount: 0.12 }}
            variants={{
                hide: {},
                show: { transition: { staggerChildren: gap, delayChildren: delay } },
            }}
        >
            {children}
        </motion.div>
    );
}

export function Item({ children, className = "" }) {
    return (
        <motion.div
            className={className}
            variants={{
                hide: { opacity: 0, y: 26 },
                show: { opacity: 1, y: 0, transition: { duration: 0.65, ease: EASE } },
            }}
        >
            {children}
        </motion.div>
    );
}

export function MaskedLines({
    lines,
    className = "",
    delay = 0,
    stagger = 0.09,
}) {
    return (
        <span className={`block ${className}`}>
            {lines.map((line, i) => (
                <span
                    key={i}
                    className="block overflow-hidden pb-[0.1em] -mb-[0.1em]"
                >
                    <motion.span
                        className="block will-change-transform"
                        initial={{ y: "112%" }}
                        animate={{ y: "0%" }}
                        transition={{
                            duration: 0.9,
                            ease: EASE,
                            delay: delay + i * stagger,
                        }}
                    >
                        {line}
                    </motion.span>
                </span>
            ))}
        </span>
    );
}
